export const OnboardingNavigationHandlers = [
    {
        key: 'default',
        displayName: 'Default',
        navigation: [
            {
                name: 'Introduction',
                key: 'landing-page',
                path: () => import('../../../views/pages/onboarding-client/steps/landing-page/landing-page')
            },
            {
                name: 'Whats Needed',
                key: 'whats-needed-page',
                path: () => import('../../../views/pages/onboarding-client/steps/whats-needed/whats-needed')
            },
            {
                name: 'Basic Info',
                key: 'basic-info-page',
                path: () => import('../../../views/pages/onboarding-client/steps/basic-info/basic-info')
            },
            {
                name: 'Suggested Offers',
                key: 'suggested-offers-page',
                path: () => import('../../../views/pages/onboarding-client/steps/offerings-selection/offerings-selection')
            },
            {
                name: 'Document Upload',
                key: 'documents-upload-page',
                path: () => import('../../../views/pages/onboarding-client/steps/documents-upload/documents-upload')
            },
            {
                name: 'Verifications',
                key: 'verifications-page',
                path: () => import('../../../views/pages/onboarding-client/steps/verification/verification')
            },
            {
                name: 'Additional Information',
                key: 'advanced-info-page',
                path: () => import('../../../views/pages/onboarding-client/steps/advanced-info/advanced-info')
            },
            {
                name: 'Summary',
                key: 'summary-page',
                path: () => import('../../../views/pages/onboarding-client/steps/summary/summary')
            },
            {
                name: 'Terms & Conditions',
                key: 'terms-conditions-page',
                path: () => import('../../../views/pages/onboarding-client/steps/terms-conditions/terms-conditions')
            },
            {
                name: 'Done',
                key: 'completed-onboarding-page',
                path: () => import('../../../views/pages/onboarding-client/steps/last-step/finished-step')
            }
        ]
    },
    {
        key: 'dynamic',
        displayName: 'Dynamic',
        navigation: [
            {
                name: 'Whats Needed',
                key: 'whats-needed-page',
                path: () => import('../../../views/pages/onboarding-client/steps/whats-needed/whats-needed')
            },
            {
                name: 'Basic Info',
                key: 'basic-info-page',
                path: () => import('../../../views/pages/onboarding-client/steps/basic-info/basic-info')
            },
            {
                name: 'Suggested Offers',
                key: 'suggested-offers-page',
                path: () => import('../../../views/pages/onboarding-client/steps/offerings-selection/offerings-selection')
            },
            {
                name: 'Document Upload',
                key: 'documents-upload-page',
                path: () => import('../../../views/pages/onboarding-client/steps/documents-upload/documents-upload')
            },
            {
                name: 'Verifications',
                key: 'verifications-page',
                path: () => import('../../../views/pages/onboarding-client/steps/verification/verification')
            },
            {
                name: 'Additional Information',
                key: 'advanced-info-page',
                path: () => import('../../../views/pages/onboarding-client/steps/advanced-info/advanced-info')
            },
            {
                name: 'Summary',
                key: 'summary-page',
                path: () => import('../../../views/pages/onboarding-client/steps/summary/summary')
            },
            {
                name: 'Terms & Conditions',
                key: 'terms-conditions-page',
                path: () => import('../../../views/pages/onboarding-client/steps/terms-conditions/terms-conditions')
            },
            {
                name: 'Done',
                key: 'completed-onboarding-page',
                path: () => import('../../../views/pages/onboarding-client/steps/last-step/finished-step')
            }
        ]
    },
    {
        key: 'single-page-form',
        displayName: 'Single Page Form',
        navigation: [
            {
                name: 'Basic Info',
                key: 'basic-info-page',
                path: () => import('../../../views/pages/onboarding-client/steps/single-page-form/single-page-form')
            },
            {
                name: 'Terms & Conditions',
                key: 'terms-conditions-page',
                path: () => import('../../../views/pages/onboarding-client/steps/terms-conditions/terms-conditions')
            },
            {
                name: 'Done',
                key: 'completed-onboarding-page',
                path: () => import('../../../views/pages/onboarding-client/steps/last-step/finished-step')
            }
        ]
    },
    {
        key: 'tabbed-page-form',
        displayName: 'Tabbed Page Form',
        navigation: [
            {
                name: 'Basic Info',
                key: 'basic-info-page',
                path: () => import('../../../views/pages/onboarding-client/steps/tabbed-page-form/tabbed-page-form')
            },
            {
                name: 'Terms & Conditions',
                key: 'terms-conditions-page',
                path: () => import('../../../views/pages/onboarding-client/steps/terms-conditions/terms-conditions')
            },
            {
                name: 'Done',
                key: 'completed-onboarding-page',
                path: () => import('../../../views/pages/onboarding-client/steps/last-step/finished-step')
            }
        ]
    }];
